import { MapPin, Clock, GraduationCap } from "lucide-react";

export default function FormationCard({ hit, onSelect }) {
  const fees = hit.fees_min && hit.fees_max
    ? hit.fees_min === hit.fees_max
      ? `${hit.fees_min.toLocaleString("fr-FR")}€`
      : `${hit.fees_min.toLocaleString("fr-FR")}€ - ${hit.fees_max.toLocaleString("fr-FR")}€`
    : hit.fees_max
    ? `≤ ${hit.fees_max.toLocaleString("fr-FR")}€`
    : null;

  const city = hit.city?.replace(/\s+arrondissement$/i, "") ?? null;

  const admissionRate = hit.admission_rate
    ? `${Math.round(hit.admission_rate * 100)} % acceptés`
    : null;

  return (
    <div
      onClick={() => onSelect(hit)}
      className="bg-gray-800 rounded-2xl border border-gray-700 hover:border-gray-600 transition cursor-pointer p-4 flex flex-col gap-2.5"
    >
      {/* Titre + école */}
      <div>
        <h3 className="font-semibold text-white text-sm leading-tight line-clamp-2">{hit.title}</h3>
        {hit.school_title && (
          <p className="text-xs text-gray-400 mt-0.5 truncate">{hit.school_title}</p>
        )}
      </div>

      {/* Badges type + durée */}
      <div className="flex flex-wrap gap-1">
        {hit.type_formation?.slice(0, 1).map((t) => (
          <span key={t} className="text-[10px] text-teal-300 bg-teal-500/10 px-2 py-0.5 rounded-full">
            {t}
          </span>
        ))}
        {hit.duration && (
          <span className="text-[10px] text-gray-400 bg-gray-700 px-2 py-0.5 rounded-full flex items-center gap-1">
            <Clock className="w-2.5 h-2.5" />
            {hit.duration}
          </span>
        )}
        {hit.apprentissage === "Obligatoire" && (
          <span className="text-[10px] text-purple-300 bg-purple-500/10 px-2 py-0.5 rounded-full">
            Alternance
          </span>
        )}
      </div>

      {/* Localisation + frais */}
      <div className="flex items-center justify-between gap-2 mt-auto">
        {city && (
          <span className="text-xs text-gray-500 flex items-center gap-1 truncate">
            <MapPin className="w-3 h-3 shrink-0" />
            {city}
          </span>
        )}
        <div className="flex items-center gap-2 shrink-0 ml-auto">
          {admissionRate && (
            <span className="text-[10px] text-orange-300 bg-orange-500/10 px-2 py-0.5 rounded-full flex items-center gap-1">
              <GraduationCap className="w-2.5 h-2.5" />
              {admissionRate}
            </span>
          )}
          {fees && (
            <span className="text-xs font-medium text-teal-400 whitespace-nowrap">{fees}</span>
          )}
        </div>
      </div>
    </div>
  );
}
